import Amplify from 'aws-amplify';
import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';
import gql from 'graphql-tag';
import {
  INTEGRATION_SERVICE_V3_AWS_CONFIG,
  PROPERTY_SERVICE_V1_AWS_CONFIG,
  PROPERTY_SERVICE_V2_AWS_CONFIG,
  PROPERTY_SERVICE_V3_AWS_CONFIG,
  PROPERTY_SERVICE_V4_AWS_CONFIG,
  PROPERTY_SERVICE_V5_AWS_CONFIG,
  PROPERTY_SERVICE_V6_AWS_CONFIG,
  PROPERTY_SERVICE_V7_AWS_CONFIG,
} from '../env/Configurations';
import { createChatMessage } from '../graphql/campaign/mutations';
import {
  activateAccommodationPackage,
  activateAccommodationPersonalization,
  activateConcierge,
  activateDirectory,
  activateHouseKeeping,
  activateIRDCategory,
  activateIRDCustomisation,
  activateRateFilter,
  addIRDAddOn,
  addIRDAllergen,
  addIRDCategory,
  addIRDCustomisation,
  addIRDDiscount,
  addIRDItem,
  addIRDMenu,
  addIRDTag,
  createBrand,
  createCampaignNotifications,
  createCategory,
  createConcierge,
  createDirectory,
  createExtension,
  createFloor,
  createHouseKeepingService,
  createIRDCombo,
  createOffer,
  createPackage,
  createPersonalisation,
  createRateFilter,
  createRoom,
  createRoomType,
  createUpgrade,
  deactivateAccommodationPackage,
  deactivateAccommodationPersonalization,
  deactivateCampaignOffer,
  deactivateConcierge,
  deactivateDirectory,
  deactivateHouseKeeping,
  deactivateIRDCategory,
  deactivateIRDCustomisation,
  deactivateOffer,
  deactivateRateFilter,
  deleteAccommodationCategory,
  deleteAccommodationFloor,
  deleteAccommodationPackage,
  deleteAccommodationPersonalization,
  deleteAccommodationRateFilter,
  deleteAccommodationRoom,
  deleteAccommodationRoomType,
  deleteAccommodationUpgrade,
  deleteBrand,
  deleteBrandByLang,
  deleteCampaignOffer,
  deleteConcierge,
  deleteDirectory,
  deleteExtension,
  deleteHouseKeeping,
  deleteIRDAddOn,
  deleteIRDAllergen,
  deleteIRDCategory,
  deleteIRDCombo,
  deleteIRDCustomisation,
  deleteIRDDiscount,
  deleteIRDItem,
  deleteIRDMenu,
  deleteIRDTag,
  deleteOffer,
  disableIRDAddOn,
  disableIRDAllergen,
  disableIRDCombo,
  disableIRDDiscount,
  disableIRDItem,
  disableIRDMenu,
  disableIRDTag,
  editIRDAddOn,
  editIRDAllergen,
  editIRDCategory,
  editIRDCustomisation,
  editIRDDiscount,
  editIRDItem,
  editIRDTag,
  enableIRDAddOn,
  enableIRDAllergen,
  enableIRDCombo,
  enableIRDDiscount,
  enableIRDItem,
  enableIRDMenu,
  enableIRDTag,
  pushNotification,
  updateBrand,
  updateBrandWithLanguage,
  updateCampaignNotifications,
  updateCategory,
  updateConcierge,
  updateDirectory,
  updateExtension,
  updateFloor,
  updateHouseKeeping,
  updateIRDCombo,
  updateIRDMenu,
  updateOffer,
  updatePackage,
  updatePersonalisation,
  updateRateFilter,
  updateRoom,
  updateRoomType,
  updateUpgrade,
  uploadExtension,
  uploadIRDCategoryByCSV,
  uploadIRDBundleByCSV,
  uploadIRDItemsByCSV,
  uploadIRDCustomisationsByCSV,
  uploadIRDTagsByCSV,
  uploadIRDAddonsByCSV,
  uploadIRDAllergensByCSV,
  uploadIRDDiscountByCSV,
  createOfferCard,
  updateOfferCard,
  deleteOfferCard,
  deactivateOfferCard,
  activateOffer,
  activateOfferCard,
  deactivateAccommodationRoomType,
  activateAccommodationRoomType,
  bulkUpdateStatus,
  bulkDelete,
  createWelcomeMessage,
  updateWelcomeMessage,
  deleteWelcomeMessage,
  updateWelcomeMessageStatus,
  duplicateWelcomeMessage,
  updatePreferenceStatus,
  updatePreference,
  createPreference,
  deletePreference,
  duplicateNotification as duplicateNotificationMutation,
  createPersonalisationCategoryMutation,
  updatePersonalisationCategoryMutation,
  deletePersonalisationCategoryMutation,
  getPersonalisationCategoriesQuery,
} from '../graphql/mutations';
import {
  conciergeDetails,
  getBrandById,
  getCampaignOffer,
  getCampaignOffersDetails,
  getInRoomDiningDetails,
  getInRoomDiningMenu,
  getIRDMenuStatus,
  getOffersDetails,
  getTelephonyDetails,
  houseKeepingDetails,
  serviceRequestDetails,
  getOfferCardsDetails,
  listWelcomeMessage,
  listWelcomeMessageVariables,
  listEmailTemplateVariables,
} from '../graphql/queries';
import { getCurrentJwtToken, getEncodedValue } from './authUtils';
import { getLov } from '../graphql/hotel/queries';

Amplify.configure({
  ...PROPERTY_SERVICE_V1_AWS_CONFIG,
});

const client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V1_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V1_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const propertyServiceV2Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V2_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V2_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const propertyServiceV3Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V3_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V3_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const propertyServiceV4Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V4_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V4_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const propertyServiceV5Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V5_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V5_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const propertyServiceV6Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V6_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V6_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

export const propertyServiceV7Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V7_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V7_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const integrationServiceV3Client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V3_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V3_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

export const creatNewBrand = async (brand, lang) => {
  return await client.mutate({
    mutation: gql(createBrand),
    variables: getEncodedValue({
      code: brand.code,
      groupId: brand.groupId,
      name: brand.name,
      description: brand.description,
      images: brand.images,
      mediaContent: brand.mediaContent,
      lang: lang,
    }),
  });
};

export const deleteBrandById = async (id, groupId) => {
  return await client.mutate({
    mutation: gql(deleteBrand),
    variables: getEncodedValue({
      id: id,
      groupId: groupId,
    }),
  });
};

export const deleteBrandByLanguage = async (id, groupId, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(deleteBrandByLang),
    variables: getEncodedValue({
      brandId: id,
      lang,
    }),
  });
};

export const updateBrandDetails = async (brand, lang) => {
  return await client.mutate({
    mutation: gql(updateBrand),
    variables: getEncodedValue({
      id: brand.id,
      code: brand.code,
      groupId: brand.groupId,
      name: brand.name,
      description: brand.description,
      images: brand.images,
      mediaContent: brand.mediaContent,
      lang: lang,
    }),
  });
};

export const updateBrandDetailsByLanguage = async (brand, lang, brandId) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(updateBrandWithLanguage),
    variables: getEncodedValue({
      brandId: brandId,
      code: brand.code,
      groupId: brand.groupId,
      name: brand.name,
      description: brand.description,
      images: brand.images,
      lang,
    }),
  });
};

export const getBrandByBrandId = async (brandId, lang) => {
  return await client.query({
    query: gql(getBrandById),
    variables: getEncodedValue({
      id: brandId,
      lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getAllInRoomDining = async (hotelId, restaurantId, lang) => {
  return await client.query({
    query: gql(getInRoomDiningDetails),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
      restaurantId: restaurantId,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getAllInRoomDiningMenu = async (hotelId, restaurantId, lang) => {
  return await client.query({
    query: gql(getInRoomDiningMenu),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
      restaurantId: restaurantId,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getServiceRequestDetails = async (hotelId, lang) => {
  return await client.query({
    query: gql(serviceRequestDetails),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getHouseKeepingDetails = async (id, hotelId, lang) => {
  return await client.query({
    query: gql(houseKeepingDetails),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getConciergeDetails = async (id, hotelId, lang) => {
  return await client.query({
    query: gql(conciergeDetails),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const deleteHousekeeing = async (id, hotelId, lang) => {
  return await client.mutate({
    mutation: gql(deleteHouseKeeping),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const deleteconcierge = async (id, hotelId, lang) => {
  return await client.mutate({
    mutation: gql(deleteConcierge),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const houseKeepingActivate = async (id, hotelId, lang) => {
  return await client.mutate({
    mutation: gql(activateHouseKeeping),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const houseKeepingDeactivate = async (id, hotelId, lang) => {
  return await client.mutate({
    mutation: gql(deactivateHouseKeeping),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const accommodationPackageDeactivate = async (id, hotelId, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(deactivateAccommodationPackage),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const accommodationPackageActivate = async (id, hotelId, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(activateAccommodationPackage),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const accommodationPersonalizationDeactivate = async (id, hotelId, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(deactivateAccommodationPersonalization),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const accommodationPersonalizationActivate = async (id, hotelId, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(activateAccommodationPersonalization),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const accommodationRoomTypeDeactivate = async (id, hotelId, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(deactivateAccommodationRoomType),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const accommodationRoomTypeActivate = async (id, hotelId, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(activateAccommodationRoomType),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const conciergeActivate = async (id, hotelId, lang) => {
  return await client.mutate({
    mutation: gql(activateConcierge),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const conciergeDeactivate = async (id, hotelId, lang) => {
  return await client.mutate({
    mutation: gql(deactivateConcierge),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const createHouseKeeping = async (payload, hotelId, lang) => {
  const maxQuantityActive = payload.maxQuantity === 'Inactive' ? false : true;
  return await client.mutate({
    mutation: gql(createHouseKeepingService),
    variables: getEncodedValue({
      hotelId: hotelId,
      images: payload.images,
      mediaContent: payload.mediaContent,
      name: payload.name,
      code: payload.code,
      description: payload.description,
      icon: payload.icon,
      confirmationMessage: payload.confirmationMessage,
      isActive: payload.isActive,
      maxQuantity: parseInt(payload.maxQuantityNum),
      maxQuantityActive: maxQuantityActive,
      schedule: payload.scheduleCheck.map((p) => p.toUpperCase()),
      scheduleActive: payload.schedule === 'Inactive' ? false : true,
      isItemActive: payload.isItemActive,
      itemList: payload.itemList,
      customAttributes: payload.customAttributes,
      hours: payload.hours,
      customSchedule: payload.customDateTime,
      lang: lang,
    }),
  });
};

export const houseKeepingUpdate = async (payload, hotelId, lang) => {
  const maxQuantityActive = payload.maxQuantity === 'Inactive' ? false : true;
  return await client.mutate({
    mutation: gql(updateHouseKeeping),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: hotelId,
      images: payload.images,
      mediaContent: payload.mediaContent,
      name: payload.name,
      code: payload.code,
      description: payload.description,
      icon: payload.icon,
      confirmationMessage: payload.confirmationMessage,
      isActive: payload.isActive,
      maxQuantity: parseInt(payload.maxQuantityNum),
      maxQuantityActive: maxQuantityActive,
      schedule: payload.scheduleCheck.map((p) => p.toUpperCase()),
      scheduleActive: payload.schedule === 'Inactive' ? false : true,
      itemList: payload.itemList,
      customAttributes: payload.customAttributes,
      isItemActive: payload.isItemActive,
      hours: payload.hours,
      customSchedule: payload.customDateTime,
      lang: lang,
    }),
  });
};

export const conciergeCreate = async (payload, hotelId, lang) => {
  const maxQuantityActive = payload.maxQuantity === 'Inactive' ? false : true;
  return await client.mutate({
    mutation: gql(createConcierge),
    variables: getEncodedValue({
      hotelId: hotelId,
      images: payload.images,
      name: payload.name,
      code: payload.code,
      resident: payload.resident === 'Resident' ? true : false,
      description: payload.description,
      icon: payload.icon,
      confirmationMessage: payload.confirmationMessage,
      isActive: payload.isActive,
      maxQuantity: parseInt(payload.maxQuantityNum),
      maxQuantityActive: maxQuantityActive,
      schedule: payload.scheduleCheck.map((p) => p.toUpperCase()),
      scheduleActive: payload.schedule === 'Inactive' ? false : true,
      itemList: payload.itemList,
      isItemActive: payload.isItemActive,
      hours: payload.hours,
      customSchedule: payload.customDateTime,
      lang: lang,
      mediaContent: payload.mediaContent,
    }),
  });
};

export const conciergeUpdate = async (payload, hotelId, lang) => {
  const maxQuantityActive = payload.maxQuantity === 'Inactive' ? false : true;
  return await client.mutate({
    mutation: gql(updateConcierge),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: hotelId,
      images: payload.images,
      name: payload.name,
      code: payload.code,
      resident: payload.resident === 'Resident' ? true : false,
      description: payload.description,
      icon: payload.icon,
      confirmationMessage: payload.confirmationMessage,
      isActive: payload.isActive,
      maxQuantity: parseInt(payload.maxQuantityNum),
      maxQuantityActive: maxQuantityActive,
      schedule: payload.scheduleCheck.map((p) => p.toUpperCase()),
      scheduleActive: payload.schedule === 'Inactive' ? false : true,
      itemList: payload.itemList,
      isItemActive: payload.isItemActive,
      hours: payload.hours,
      customSchedule: payload.customDateTime,
      lang: lang,
      mediaContent: payload.mediaContent,
    }),
  });
};

export const addInRoomDiningCategory = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addIRDCategory),
    variables: getEncodedValue({
      name: payload.name,
      code: payload.code,
      description: payload.description,
      status: payload.status,
      hours: payload.hours,
      images: payload.images,
      customAttributes: payload.customAttributes,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const uploadIRDCategoriesByCSV = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(uploadIRDCategoryByCSV),
    variables: getEncodedValue({
      isReplace: payload.isReplace,
      hotelId: payload.hotelId,
      category: payload.category,
      lang: lang,
      restaurantId: payload.restaurantId,
    }),
  });
};

export const uploadIRDComboByCSV = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(uploadIRDBundleByCSV),
    variables: getEncodedValue({
      isReplace: payload.isReplace,
      hotelId: payload.hotelId,
      bundles: payload.bundles,
      lang: lang,
      restaurantId: payload.restaurantId,
    }),
  });
};

export const uploadIRDItemByCSV = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(uploadIRDItemsByCSV),
    variables: getEncodedValue({
      isReplace: payload.isReplace,
      hotelId: payload.hotelId,
      items: payload.items,
      lang: lang,
      restaurantId: payload.restaurantId,
    }),
  });
};

export const uploadIRDCustomizationsByCSV = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(uploadIRDCustomisationsByCSV),
    variables: getEncodedValue({
      isReplace: payload.isReplace,
      hotelId: payload.hotelId,
      customisations: payload.customisations,
      lang: lang,
      restaurantId: payload.restaurantId,
    }),
  });
};

export const uploadIRDAddOnsByCSV = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(uploadIRDAddonsByCSV),
    variables: getEncodedValue({
      isReplace: payload.isReplace,
      hotelId: payload.hotelId,
      addons: payload.addons,
      lang: lang,
      restaurantId: payload.restaurantId,
    }),
  });
};

export const uploadIRDTagByCSV = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(uploadIRDTagsByCSV),
    variables: getEncodedValue({
      isReplace: payload.isReplace,
      hotelId: payload.hotelId,
      tags: payload.tags,
      lang: lang,
      restaurantId: payload.restaurantId,
    }),
  });
};

export const uploadIRDAllergenByCSV = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(uploadIRDAllergensByCSV),
    variables: getEncodedValue({
      isReplace: payload.isReplace,
      hotelId: payload.hotelId,
      allergens: payload.allergens,
      lang: lang,
      restaurantId: payload.restaurantId,
    }),
  });
};

export const uploadIRDDiscountsByCSV = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(uploadIRDDiscountByCSV),
    variables: getEncodedValue({
      isReplace: payload.isReplace,
      hotelId: payload.hotelId,
      discounts: payload.discounts,
      lang: lang,
      restaurantId: payload.restaurantId,
    }),
  });
};

export const editInRoomDiningCategory = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(editIRDCategory),
    variables: getEncodedValue({
      id: payload.id,
      name: payload.name,
      code: payload.code,
      description: payload.description,
      status: payload.status,
      hours: payload.hours,
      images: payload.images,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      customAttributes: payload.customAttributes,
      lang: lang,
    }),
  });
};

export const deactivateInRoomDiningCategoty = async (categoryId, hotelId, restaurantId, lang) => {
  return await client.mutate({
    mutation: gql(deactivateIRDCategory),
    variables: getEncodedValue({ id: categoryId, hotelId, restaurantId, lang }),
  });
};

export const activateInRoomDiningCategoty = async (categoryId, hotelId, restaurantId, lang) => {
  return await client.mutate({
    mutation: gql(activateIRDCategory),
    variables: getEncodedValue({ id: categoryId, hotelId, restaurantId, lang }),
  });
};

export const deleteInRoomDiningCategory = async (categoryId, hotelId, restaurantId, lang) => {
  return await client.mutate({
    mutation: gql(deleteIRDCategory),
    variables: getEncodedValue({ id: categoryId, hotelId, restaurantId, lang }),
  });
};

export const addInRoomDiningItem = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addIRDItem),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      status: payload.status,
      type: payload.type,
      code: payload.code,
      name: payload.name,
      price: payload.price,
      description: payload.description,
      ingredients: payload.ingredients,
      allergens: payload.allergens,
      tags: payload.tags,
      addons: payload.addons,
      customisation: payload.customisation,
      upsell: payload.upsell,
      discount: payload.discount,
      images: payload.images,
      customAttributes: payload.customAttributes,
      lang: lang,
    }),
  });
};

export const editInRoomDiningItem = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(editIRDItem),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      status: payload.status,
      type: payload.type,
      code: payload.code,
      name: payload.name,
      price: payload.price,
      description: payload.description,
      ingredients: payload.ingredients,
      allergens: payload.allergens,
      tags: payload.tags,
      addons: payload.addons,
      customisation: payload.customisation,
      upsell: payload.upsell,
      discount: payload.discount,
      images: payload.images,
      customAttributes: payload.customAttributes,
      lang: lang,
    }),
  });
};

export const deleteInRoomDiningItem = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(deleteIRDItem),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const activateInRoomDiningItem = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(enableIRDItem),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const deactivateInRoomDiningItem = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(disableIRDItem),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const addInRoomDiningTag = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addIRDTag),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      name: payload.name,
      code: payload.code,
      customAttributes: payload.customAttributes,
      status: payload.status,
      lang: lang,
    }),
  });
};

export const editInRoomDiningTag = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(editIRDTag),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      name: payload.name,
      code: payload.code,
      customAttributes: payload.customAttributes,
      status: payload.status,
      lang: lang,
    }),
  });
};

export const deleteInRoomDiningTag = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(deleteIRDTag),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const addInRoomDiningAllergen = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addIRDAllergen),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      name: payload.name,
      code: payload.code,
      customAttributes: payload.customAttributes,
      status: payload.status,
      lang: lang,
    }),
  });
};

export const editInRoomDiningAllergen = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(editIRDAllergen),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      name: payload.name,
      code: payload.code,
      customAttributes: payload.customAttributes,
      status: payload.status,
      lang: lang,
    }),
  });
};

export const deleteInRoomDiningAllergen = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(deleteIRDAllergen),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const addInRoomDiningAddOn = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addIRDAddOn),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      name: payload.name,
      code: payload.code,
      status: payload.status,
      price: payload.price,
      customAttributes: payload.customAttributes,
      lang: lang,
      priceInDecimal: payload.priceInDecimal,
    }),
  });
};

export const editInRoomDiningAddOn = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(editIRDAddOn),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      name: payload.name,
      code: payload.code,
      status: payload.status,
      price: payload.price,
      customAttributes: payload.customAttributes,
      lang: lang,
      priceInDecimal: payload.priceInDecimal,
    }),
  });
};

export const deleteInRoomDiningAddOn = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(deleteIRDAddOn),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const activateInRoomDiningAddOn = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(enableIRDAddOn),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const deactivateInRoomDiningAddOn = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(disableIRDAddOn),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const activateInRoomDiningTag = async (payload, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(enableIRDTag),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const deactivateInRoomDiningTag = async (payload, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(disableIRDTag),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const activateInRoomDiningAllergen = async (payload, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(enableIRDAllergen),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const deactivateInRoomDiningAllergen = async (payload, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(disableIRDAllergen),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const activateInRoomDiningDiscount = async (payload, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(enableIRDDiscount),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const deactivateInRoomDiningDiscount = async (payload, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(disableIRDDiscount),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};
export const addInRoomDiningCustomisation = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addIRDCustomisation),
    variables: getEncodedValue({
      name: payload.name,
      code: payload.code,
      status: payload.status,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      customAttributes: payload.customAttributes,
      lang: lang,
    }),
  });
};

export const editInRoomDiningCustomisation = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(editIRDCustomisation),
    variables: getEncodedValue({
      id: payload.id,
      name: payload.name,
      code: payload.code,
      status: payload.status,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      customAttributes: payload.customAttributes,
      lang: lang,
    }),
  });
};

export const deactivateInRoomDiningCustomisation = async (id, hotelId, restaurantId, lang) => {
  return await client.mutate({
    mutation: gql(deactivateIRDCustomisation),
    variables: getEncodedValue({
      id,
      hotelId,
      restaurantId,
      lang,
    }),
  });
};

export const activateInRoomDiningCustomisation = async (id, hotelId, restaurantId, lang) => {
  return await client.mutate({
    mutation: gql(activateIRDCustomisation),
    variables: getEncodedValue({
      id,
      hotelId,
      restaurantId,
      lang,
    }),
  });
};

export const deleteInRoomDiningCustomisation = async (id, hotelId, restaurantId, lang) => {
  return await client.mutate({
    mutation: gql(deleteIRDCustomisation),
    variables: getEncodedValue({
      id,
      hotelId,
      restaurantId,
      lang,
    }),
  });
};

export const addInRoomDiningDiscount = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addIRDDiscount),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      code: payload.code,
      name: payload.name,
      value: payload.value,
      upto: payload.upto,
      disclaimer: payload.disclaimer,
      description: payload.description,
      schedule: payload.schedule,
      status: payload.status,
      customAttributes: payload.customAttributes,
      lang: lang,
    }),
  });
};

export const editInRoomDiningDiscount = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(editIRDDiscount),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      id: payload.id,
      code: payload.code,
      name: payload.name,
      value: payload.value,
      upto: payload.upto,
      disclaimer: payload.disclaimer,
      description: payload.description,
      schedule: payload.schedule,
      status: payload.status,
      customAttributes: payload.customAttributes,
      lang: lang,
    }),
  });
};

export const deleteInRoomDiningDiscount = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(deleteIRDDiscount),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang: lang,
    }),
  });
};

export const createInRoomDiningCombo = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(createIRDCombo),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      code: payload.code,
      name: payload.name,
      status: payload.status,
      price: payload.price,
      description: payload.description,
      items: payload.items,
      addons: payload.addons,
      upsellStatus: payload.upsellStatus,
      upsellItems: payload.upsellItems,
      images: payload.images,
      customAttributes: payload.customAttributes,
      lang: lang,
      addonsStatus: payload.addonsStatus,
    }),
  });
};

export const updateInRoomDiningCombo = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(updateIRDCombo),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      id: payload.id,
      code: payload.code,
      name: payload.name,
      status: payload.status,
      price: payload.price,
      description: payload.description,
      items: payload.items,
      addonsStatus: payload.addonsStatus,
      limit: payload.limit,
      value: payload.value,
      addons: payload.addons,
      upsellStatus: payload.upsellStatus,
      upsellItems: payload.upsellItems,
      images: payload.images,
      customAttributes: payload.customAttributes,
      lang: lang,
    }),
  });
};

export const deactivateInRoomDiningCombo = async (id, hotelId, restaurantId, lang) => {
  return await client.mutate({
    mutation: gql(disableIRDCombo),
    variables: getEncodedValue({
      id,
      hotelId,
      restaurantId,
      lang,
    }),
  });
};

export const activateInRoomDiningCombo = async (id, hotelId, restaurantId, lang) => {
  return await client.mutate({
    mutation: gql(enableIRDCombo),
    variables: getEncodedValue({
      id,
      hotelId,
      restaurantId,
      lang,
    }),
  });
};

export const deleteInRoomDiningCombo = async (id, hotelId, restaurantId, lang) => {
  return await client.mutate({
    mutation: gql(deleteIRDCombo),
    variables: getEncodedValue({
      id,
      hotelId,
      restaurantId,
      lang,
    }),
  });
};

export const addInRoomDiningMenu = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(addIRDMenu),
    variables: getEncodedValue({
      code: payload.code,
      name: payload.name,
      description: payload.description,
      isActive: payload.isActive,
      hours: payload.hours,
      categories: payload.categories,
      images: payload.images,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      menuURL: payload.menuURL,
      menuType: payload.menuType,
      lang: lang,
    }),
  });
};

export const updateInRoomDiningMenu = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(updateIRDMenu),
    variables: getEncodedValue({
      code: payload.code,
      name: payload.name,
      description: payload.description,
      isActive: payload.isActive,
      hours: payload.hours,
      categories: payload.categories,
      images: payload.images,
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      id: payload.id,
      menuURL: payload.menuURL,
      menuType: payload.menuType,
      lang: lang,
    }),
  });
};

export const deactiveInRoomDiningMenu = async (hotelId, restaurantId, id, lang) => {
  return await client.mutate({
    mutation: gql(disableIRDMenu),
    variables: getEncodedValue({
      hotelId,
      restaurantId,
      id,
      lang,
    }),
  });
};

export const activeInRoomDiningMenu = async (hotelId, restaurantId, id, lang) => {
  return await client.mutate({
    mutation: gql(enableIRDMenu),
    variables: getEncodedValue({
      hotelId,
      restaurantId,
      id,
      lang,
    }),
  });
};

export const deleteInRoomDiningMenu = async (hotelId, restaurantId, id, lang) => {
  return await client.mutate({
    mutation: gql(deleteIRDMenu),
    variables: getEncodedValue({
      hotelId,
      restaurantId,
      id,
      lang,
    }),
  });
};

export const getInRoomDiningPosMenu = async (hotelId, lang) => {
  return await client.query({
    query: gql(getIRDMenuStatus),
    variables: getEncodedValue({
      hotelId,
      lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getOfferList = async (hotelId, lang) => {
  return await propertyServiceV2Client.query({
    query: gql(getOffersDetails),
    variables: getEncodedValue({
      hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getOfferCardsList = async (hotelId, getByLang) => {
  return await propertyServiceV5Client.query({
    query: gql(getOfferCardsDetails),
    variables: getEncodedValue({
      hotelId,
      lang: getByLang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const deactivateOfferDetail = async (payload, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deactivateOffer),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      id: payload.id,
      lang: lang,
    }),
  });
};

export const activateOfferCardDetail = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(activateOfferCard),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      id: payload.id,
      lang: lang,
    }),
  });
};

export const deactivateOfferCardDetail = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(deactivateOfferCard),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      id: payload.id,
      lang: lang,
    }),
  });
};

export const createNewOffer = async (payload, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createOffer),
    variables: getEncodedValue({
      CTA: payload.CTA,
      description: payload.description,
      duration: payload.duration,
      highLights: payload.highLights,
      hotelId: payload.hotelId,
      images: payload.images,
      name: payload.name,
      type: payload.type,
      customAttributes: payload.customAttributes,
      contact: payload.contact,
      lang: lang,
      selectRestaurant: payload.selectRestaurant,
    }),
  });
};

export const createNewOfferCard = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(createOfferCard),
    variables: getEncodedValue({
      CTA: payload.CTA,
      offerCardName: payload.offerCardName,
      offerRecipient: payload.offerRecipient,
      hotelId: payload.hotelId,
      preScratchImages: payload.preScratchImages,
      postScratchImages: payload.postScratchImages,
      offerCardType: payload.offerCardType,
      customAttributes: payload.customAttributes,
      offerId: payload.offerId,
      lang: lang,
      schedule: payload.schedule,
      offerName: payload.offerName,
      popUpImages: payload.popUpImages,
    }),
  });
};

export const updateOfferCards = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(updateOfferCard),
    variables: getEncodedValue({
      id: payload.id,
      CTA: payload.CTA,
      offerCardName: payload.offerCardName,
      offerRecipient: payload.offerRecipient,
      hotelId: payload.hotelId,
      preScratchImages: payload.preScratchImages,
      postScratchImages: payload.postScratchImages,
      offerCardType: payload.offerCardType,
      customAttributes: payload.customAttributes,
      offerId: payload.offerId,
      lang: lang,
      schedule: payload.schedule,
      offerName: payload.offerName,
      popUpImages: payload.popUpImages,
    }),
  });
};

export const activateOfferDetail = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(activateOffer),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      id: payload.id,
      lang: lang,
    }),
  });
};

export const updateExistingOffer = async (payload, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updateOffer),
    variables: getEncodedValue({
      CTA: payload.CTA,
      description: payload.description,
      duration: payload.duration,
      highLights: payload.highLights,
      hotelId: payload.hotelId,
      id: payload.id,
      images: payload.images,
      name: payload.name,
      type: payload.type,
      customAttributes: payload.customAttributes,
      contact: payload.contact,
      lang: lang,
      selectRestaurant: payload.selectRestaurant,
    }),
  });
};

export const deleteOfferDetail = async (payload, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteOffer),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      id: payload.id,
      lang: lang,
    }),
  });
};

export const deleteOfferCardDetail = async (payload, lang) => {
  return await propertyServiceV5Client.mutate({
    mutation: gql(deleteOfferCard),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      id: payload.id,
      lang: lang,
    }),
  });
};

export const createOfferNotification = async (payload, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(pushNotification),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      id: payload.id,
      notification: payload.notification,
      lang: lang,
    }),
  });
};

// Accommodations APIs starts here

export const creatHotelCategory = async (category, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createCategory),
    variables: getEncodedValue({
      code: category.code,
      name: category.name,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const updateHotelCategory = async (category, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updateCategory),
    variables: getEncodedValue({
      code: category.code,
      name: category.name,
      hotelId: hotelId,
      id: category.id,
      lang: lang,
    }),
  });
};

export const creatNewRoomType = async (roomType, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createRoomType),
    variables: getEncodedValue({
      code: roomType.code,
      name: roomType.name,
      categoryId: roomType.categoryId,
      description: roomType.description,
      displayDescription: roomType.displayDescription,
      displayName: roomType.displayName,
      features: roomType.features,
      images: roomType.images,
      mediaContent: roomType.mediaContent,
      maxAdults: roomType.maxAdults,
      maxBeddingPerRoomType: roomType.maxBeddingPerRoomType,
      maxChildren: roomType.maxChildren,
      maxInfants: roomType.maxInfants,
      maxOccupants: roomType.maxOccupants,
      ratePerNight: roomType.ratePerNight,
      hotelId: hotelId,
      lang: lang,
      isActive: roomType?.isActive,
    }),
  });
};

export const updateRoomTypeDetails = async (roomType, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updateRoomType),
    variables: getEncodedValue({
      code: roomType.code,
      name: roomType.name,
      categoryId: roomType.categoryId,
      description: roomType.description,
      displayDescription: roomType.displayDescription,
      displayName: roomType.displayName,
      features: roomType.features,
      images: roomType.images,
      mediaContent: roomType.mediaContent,
      maxAdults: roomType.maxAdults,
      maxBeddingPerRoomType: roomType.maxBeddingPerRoomType,
      maxChildren: roomType.maxChildren,
      maxInfants: roomType.maxInfants,
      maxOccupants: roomType.maxOccupants,
      ratePerNight: roomType.ratePerNight,
      hotelId: hotelId,
      id: roomType.id,
      lang: lang,
      isActive: roomType?.isActive,
    }),
  });
};

export const createHotelFloor = async (floor, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createFloor),
    variables: getEncodedValue({
      number: floor.number,
      name: floor.name,
      hotelId: hotelId,
      roomRangeList: floor.rooms,
      lang: lang,
    }),
  });
};

export const updateHotelFloor = async (floor, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updateFloor),
    variables: getEncodedValue({
      id: floor.id,
      number: floor.number,
      name: floor.name,
      hotelId: hotelId,
      roomRangeList: floor.rooms,
      lang: lang,
    }),
  });
};

export const createHotelRoom = async (room, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createRoom),
    variables: getEncodedValue({
      number: room.number,
      roomTypeId: room.roomTypeId,
      area: room.area,
      areaSizeUnit: room.areaSizeUnit,
      description: room.description,
      houseKeepingDaySection: room.houseKeepingDaySection,
      houseKeepingEveningSection: room.houseKeepingEveningSection,
      isSmokingAllowed: room.isSmokingAllowed,
      maxOccupancy: room.maxOccupancy,
      roomView: room.roomView,
      isActive: room.isActive,
      isAdultRequired: room.isAdultRequired,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const updateHotelRoom = async (room, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updateRoom),
    variables: getEncodedValue({
      id: room.id,
      number: room.number,
      roomTypeId: room.roomTypeId,
      area: room.area,
      areaSizeUnit: room.areaSizeUnit,
      description: room.description,
      houseKeepingDaySection: room.houseKeepingDaySection,
      houseKeepingEveningSection: room.houseKeepingEveningSection,
      isSmokingAllowed: room.isSmokingAllowed,
      maxOccupancy: room.maxOccupancy,
      roomView: room.roomView,
      isActive: room.isActive,
      isAdultRequired: room.isAdultRequired,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const createNewPersonalisation = async (hotelId, personalisation, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createPersonalisation),
    variables: getEncodedValue({
      hotelId: hotelId,
      code: personalisation.code,
      cost: personalisation.cost,
      description: personalisation.description,
      isActive: personalisation.isActive,
      name: personalisation.name,
      unit: personalisation.unit,
      maxQuantity: personalisation.maxQuantity,
      personalisationCategory: personalisation.personalisationCategory,
      lang: lang,
    }),
  });
};

export const createHotelRateFilter = async (hotelId, rateFilter, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(createRateFilter),
    variables: getEncodedValue({
      hotelId: hotelId,
      code: rateFilter.code,
      displayName: rateFilter.displayName,
      description: rateFilter.description,
      isActive: rateFilter.isActive,
      name: rateFilter.name,
      customAttributes: rateFilter.customAttributes,
      rateCodeDescription: rateFilter.rateCodeDescription,
      rateCodes: rateFilter.rateCodes,
      lang: lang,
    }),
  });
};

export const updateHotelRateFilter = async (hotelId, rateFilter, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(updateRateFilter),
    variables: getEncodedValue({
      hotelId: hotelId,
      code: rateFilter.code,
      displayName: rateFilter.displayName,
      description: rateFilter.description,
      isActive: rateFilter.isActive,
      name: rateFilter.name,
      customAttributes: rateFilter.customAttributes,
      rateCodeDescription: rateFilter.rateCodeDescription,
      rateCodes: rateFilter.rateCodes,
      id: rateFilter.id,
      lang: lang,
    }),
  });
};

export const deleteAccommodationRateFilterAPI = async (hotelId, packageId, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(deleteAccommodationRateFilter),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
      id: packageId,
    }),
  });
};
export const createNewUpgrade = async (hotelId, upgrade, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createUpgrade),
    variables: getEncodedValue({
      hotelId: hotelId,
      roomTypeId: upgrade.roomTypeId,
      upgradeType: upgrade.upgradeType,
      lang: lang,
    }),
  });
};

export const updateHotelPersonalisation = async (hotelId, personalisation, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updatePersonalisation),
    variables: getEncodedValue({
      hotelId: hotelId,
      code: personalisation.code,
      cost: personalisation.cost,
      description: personalisation.description,
      isActive: personalisation.isActive,
      name: personalisation.name,
      unit: personalisation.unit,
      maxQuantity: personalisation.maxQuantity,
      personalisationCategory: personalisation.personalisationCategory,
      id: personalisation.id,
      lang: lang,
    }),
  });
};

export const getPersonalisationCategoriesAPI = async (hotelId) => {
  return await propertyServiceV7Client.query({
    query: gql(getPersonalisationCategoriesQuery),
    variables: { hotelId },
    fetchPolicy: 'network-only',
  });
};

export const createPersonalisationCategoryAPI = async (hotelId, categoryName) => {
  return await propertyServiceV7Client.mutate({
    mutation: gql(createPersonalisationCategoryMutation),
    variables: { hotelId, categoryName },
  });
};

export const updatePersonalisationCategoryAPI = async (hotelId, categoryName, id) => {
  return await propertyServiceV7Client.mutate({
    mutation: gql(updatePersonalisationCategoryMutation),
    variables: { hotelId, categoryName, id },
  });
};

export const deletePersonalisationCategoryAPI = async (hotelId, id) => {
  return await propertyServiceV7Client.mutate({
    mutation: gql(deletePersonalisationCategoryMutation),
    variables: { hotelId, id },
  });
};

export const updateHotelUpgrade = async (hotelId, upgrade, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updateUpgrade),
    variables: getEncodedValue({
      hotelId: hotelId,
      id: upgrade.id,
      roomTypeId: upgrade.roomTypeId,
      upgradeType: upgrade.upgradeType,
      lang: lang,
    }),
  });
};

export const createHotelPackage = async (obj, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createPackage),
    variables: getEncodedValue({
      name: obj.name,
      code: obj.code,
      description: obj.description,
      costPerNight: obj.costPerNight,
      images: obj.images,
      isActive: obj.isActive,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const updateHotelPackage = async (obj, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updatePackage),
    variables: getEncodedValue({
      id: obj.id,
      name: obj.name,
      code: obj.code,
      description: obj.description,
      costPerNight: obj.costPerNight,
      images: obj.images,
      isActive: obj.isActive,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const createPreferenceAPI = async (payload) => {
  return await propertyServiceV7Client.mutate({
    mutation: gql(createPreference),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      code: payload.code,
      name: payload.name,
      isActive: payload.isActive,
      lang: payload.lang,
      allowMultipleSelection: payload.allowMultipleSelection,
      description: payload.description,
      customAttributes: payload.customAttributes,
      preferenceItems: payload.preferenceItems,
    }),
  });
};

export const updatePreferenceAPI = async (payload) => {
  return await propertyServiceV7Client.mutate({
    mutation: gql(updatePreference),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      id: payload.id,
      code: payload.code,
      name: payload.name,
      isActive: payload.isActive,
      lang: payload.lang,
      allowMultipleSelection: payload.allowMultipleSelection,
      description: payload.description,
      customAttributes: payload.customAttributes,
      preferenceItems: payload.preferenceItems,
    }),
  });
};

export const deletePreferenceAPI = async ({ hotelId, id }) => {
  return await propertyServiceV7Client.mutate({
    mutation: gql(deletePreference),
    variables: getEncodedValue({ hotelId, id }),
  });
};

export const updatePreferenceStatusAPI = async ({ hotelId, id, lang }) => {
  return await propertyServiceV7Client.mutate({
    mutation: gql(updatePreferenceStatus),
    variables: getEncodedValue({ hotelId, id, lang }),
  });
};

export const deleteAccommodationCategoryAPI = async (hotelId, categoryId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteAccommodationCategory),
    variables: getEncodedValue({
      hotelId: hotelId,
      id: categoryId,
      lang: lang,
    }),
  });
};

export const deleteAccommodationPackageAPI = async (hotelId, packageId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteAccommodationPackage),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
      id: packageId,
    }),
  });
};

export const deleteAccommodationRoomAPI = async (hotelId, roomId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteAccommodationRoom),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
      id: roomId,
    }),
  });
};

export const deleteAccommodationPersonalizationAPI = async (hotelId, personalisationId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteAccommodationPersonalization),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
      id: personalisationId,
    }),
  });
};

export const deleteAccommodationUpgradeAPI = async (hotelId, upgrageId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteAccommodationUpgrade),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
      id: upgrageId,
    }),
  });
};

export const deleteAccommodationFloorAPI = async (hotelId, floorId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteAccommodationFloor),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
      id: floorId,
    }),
  });
};

export const deleteAccommodationRoomTypeAPI = async (hotelId, roomTypeId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteAccommodationRoomType),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
      id: roomTypeId,
    }),
  });
};

export const getAllTelephony = async (hotelId, lang) => {
  return await propertyServiceV2Client.query({
    query: gql(getTelephonyDetails),
    variables: getEncodedValue({
      hotelId,
      lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const createTelephonyExtension = async (payload, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createExtension),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      roomNumber: payload.roomNumber,
      extensionNumber: payload.extensionNumber,
      password: payload.password,
      lang: lang,
    }),
  });
};

export const updateTelephonyExtension = async (payload, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updateExtension),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      id: payload.id,
      roomNumber: payload.roomNumber,
      extensionNumber: payload.extensionNumber,
      password: payload.password,
      lang: lang,
    }),
  });
};

export const deleteTelephonyExtension = async (payload, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteExtension),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      id: payload.id,
      lang: lang,
    }),
  });
};

export const createTelephonyDirectories = async (payload, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(createDirectory),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      name: payload.name,
      code: payload.code,
      extensionNumber: payload.extensionNumber,
      extensionPassword: payload.extensionPassword,
      icon: payload.icon,
      description: payload.description,
      isActive: payload.isActive,
      lang: lang,
    }),
  });
};

export const updateTelephonyDirectories = async (payload, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(updateDirectory),
    variables: getEncodedValue({
      hotelId: payload.hotelId,
      name: payload.name,
      code: payload.code,
      extensionNumber: payload.extensionNumber,
      extensionPassword: payload.extensionPassword,
      icon: payload.icon,
      description: payload.description,
      isActive: payload.isActive,
      id: payload.id,
      lang: lang,
    }),
  });
};

export const deactivateDirectories = async (id, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deactivateDirectory),
    variables: getEncodedValue({
      id,
      hotelId,
      lang,
    }),
  });
};

export const activateDirectories = async (id, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(activateDirectory),
    variables: getEncodedValue({
      id,
      hotelId,
      lang,
    }),
  });
};

export const deleteDirectories = async (id, hotelId, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(deleteDirectory),
    variables: getEncodedValue({
      id,
      hotelId,
      lang,
    }),
  });
};

export const uploadTelephonyExtension = async (payload, lang) => {
  return await propertyServiceV2Client.mutate({
    mutation: gql(uploadExtension),
    variables: getEncodedValue({
      IsReplace: payload.isReplace,
      hotelId: payload.hotelId,
      extensions: payload.extensions,
      lang: lang,
    }),
  });
};

export const getCampaignNotifications = async (hotelId, lang) => {
  return await propertyServiceV3Client.query({
    query: gql(getCampaignOffersDetails),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getCampaignNotificationsById = async (id, hotelId, lang) => {
  return await propertyServiceV3Client.query({
    query: gql(getCampaignOffer),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const createNotifications = async (payload, hotelId, lang) => {
  return await propertyServiceV3Client.mutate({
    mutation: gql(createCampaignNotifications),
    variables: getEncodedValue({
      hotelId: hotelId,
      type: payload?.type,
      title: payload?.title,
      message: payload?.message,
      devices: payload?.devices,
      recipient: payload?.recipient,
      images: payload?.images,
      offerSchedule: payload?.offerSchedule,
      timezone: payload?.timezone,
      timeOffset: payload?.timeOffset,
      residentFloor: payload?.residentFloor,
      residentRoomType: payload?.residentRoomType,
      residentRoom: payload?.residentRoom,
      residentRoomTypeIds: payload?.residentRoomTypeIds,
      residentFloorIds: payload?.residentFloorIds,
      lang: lang,
      mediaContent: payload?.mediaContent,
    }),
  });
};

export const updateNotifications = async (payload, hotelId, lang) => {
  return await propertyServiceV3Client.mutate({
    mutation: gql(updateCampaignNotifications),
    variables: getEncodedValue({
      id: payload?.id,
      hotelId: hotelId,
      type: payload?.type,
      title: payload?.title,
      message: payload?.message,
      devices: payload?.devices,
      recipient: payload?.recipient,
      images: payload?.images,
      offerSchedule: payload?.offerSchedule,
      timezone: payload?.timezone,
      timeOffset: payload?.timeOffset,
      residentFloor: payload?.residentFloor,
      residentRoomType: payload?.residentRoomType,
      residentRoom: payload?.residentRoom,
      residentRoomTypeIds: payload?.residentRoomTypeIds,
      residentFloorIds: payload?.residentFloorIds,
      lang: lang,
      mediaContent: payload?.mediaContent,
    }),
  });
};

export const deleteNotification = async (id, hotelId, lang) => {
  return await propertyServiceV3Client.mutate({
    mutation: gql(deleteCampaignOffer),
    variables: getEncodedValue({
      id,
      hotelId,
      lang: lang,
    }),
  });
};

export const deactivateNotification = async (id, hotelId, lang, state = false) => {
  return await propertyServiceV3Client.mutate({
    mutation: gql(deactivateCampaignOffer),
    variables: getEncodedValue({
      id,
      hotelId,
      lang: lang,
      state,
    }),
  });
};

export const sendSMS = async (body, guestId, hotelId, threadId, reservationId) => {
  return await integrationServiceV3Client.mutate({
    mutation: gql(createChatMessage),
    variables: getEncodedValue({
      body: body,
      guestId: guestId,
      hotelId: hotelId,
      threadId: threadId,
      reservationId: reservationId,
    }),
  });
};

export const accommodationRateFiltersDeactivate = async (id, hotelId, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(deactivateRateFilter),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const accommodationRateFiltersActivate = async (id, hotelId, lang) => {
  return await propertyServiceV4Client.mutate({
    mutation: gql(activateRateFilter),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const updateSelectedItemsStatus = async (
  ids,
  hotelId,
  lang,
  module,
  restaurantId,
  status,
  all,
) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(bulkUpdateStatus),
    variables: getEncodedValue({
      ids: ids,
      hotelId: hotelId,
      lang: lang,
      module: module,
      restaurantId: restaurantId,
      status: status,
      all: all,
    }),
  });
};

export const deleteSelectedItems = async (ids, hotelId, lang, module, restaurantId, all) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(bulkDelete),
    variables: getEncodedValue({
      ids: ids,
      hotelId: hotelId,
      lang: lang,
      module: module,
      restaurantId: restaurantId,
      all: all,
    }),
  });
};

export const getWelcomeMessages = async (hotelId, lang) => {
  return await propertyServiceV6Client.query({
    query: gql(listWelcomeMessage),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
    }),
    fetchPolicy: 'network-only',
  });
};

export const getWelcomeMessageVariables = async () => {
  return await propertyServiceV6Client.query({
    query: gql(listWelcomeMessageVariables),
    fetchPolicy: 'network-only',
  });
};

export const getEmailTemplateVariables = async (listType = 'templateTypes') => {
  return await propertyServiceV7Client.query({
    query: gql(listEmailTemplateVariables),
    variables: { listType },
    fetchPolicy: 'network-only',
  });
};

export const createNewWelcomeMessage = async (payload, hotelId, lang) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(createWelcomeMessage),
    variables: getEncodedValue({
      hotelId: hotelId,
      title: payload.title,
      welcomeMessageTemplate: JSON.stringify(payload.welcomeMessageTemplate),
      deviceTypes: payload.deviceTypes,
      isActive: payload.isActive,
      confirmationIds: payload.confirmationIds,
      audienceType: payload.audienceType,
      audienceCriteria: payload.audienceCriteria,
      lang: lang,
    }),
  });
};

export const updateExistingWelcomeMessage = async (payload, hotelId, lang) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(updateWelcomeMessage),
    variables: getEncodedValue({
      id: payload.id,
      hotelId: hotelId,
      title: payload.title,
      welcomeMessageTemplate: JSON.stringify(payload.welcomeMessageTemplate),
      deviceTypes: payload.deviceTypes,
      isActive: payload.isActive,
      confirmationIds: payload.confirmationIds,
      audienceType: payload.audienceType,
      audienceCriteria: payload.audienceCriteria,
      lang: lang,
    }),
  });
};

export const deleteWelcomeMessageById = async (id, hotelId, lang) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(deleteWelcomeMessage),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const toggleWelcomeMessageStatus = async (id, hotelId, lang) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(updateWelcomeMessageStatus),
    variables: getEncodedValue({
      id: id,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const duplicateWelcomeMessageById = async (id, title, hotelId, lang) => {
  return await propertyServiceV6Client.mutate({
    mutation: gql(duplicateWelcomeMessage),
    variables: getEncodedValue({
      id: id,
      title: title,
      hotelId: hotelId,
      lang: lang,
    }),
  });
};

export const duplicateNotification = async (id, hotelId, lang, name) => {
  return await propertyServiceV7Client.mutate({
    mutation: gql(duplicateNotificationMutation),
    variables: getEncodedValue({
      id,
      hotelId,
      name,
      lang,
    }),
  });
};

export const fetchLovData = async (hotelId, lang, listName) => {
  return await propertyServiceV6Client.query({
    query: gql(getLov),
    variables: getEncodedValue({
      hotelId: hotelId,
      lang: lang,
      listName: listName,
    }),
    fetchPolicy: 'network-only',
  });
};
